import type { SxStyle } from '@aibees/shared/theme';
import {
  advanceTableSelectionPopupItem,
  advanceTableSelectionPopupItemText,
} from '../../sx';

export const root: SxStyle = advanceTableSelectionPopupItem;
export const inputContentRow: SxStyle = {
  justifyContent: 'flex-end',
};

export const label: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(1),
};

export const labelText: SxStyle = {
  color: (p) => p.palette.grey[700],
  whiteSpace: 'nowrap',
};

export const input: SxStyle = {
  '& input': {
    textAlign: 'center',
    color: (p) => p.palette.grey[800],
  },
};

export const text: SxStyle = advanceTableSelectionPopupItemText;
